import { extendZodWithOpenApi } from '@anatine/zod-openapi'
import { z } from 'zod'

extendZodWithOpenApi(z)

export const TenantType = z.enum([
  'LykaStaff',
  'Partner',
  'FulfillmentStaff',
  'D2cCustomer',
  'Guest',
  'TygaCustomer',
  'TygaLead',
  'LykaLead',
  'CustomerCare',
])
export type TenantType = z.infer<typeof TenantType>

export const GetUsersResponse = z.object({
  result: z.array(
    z.object({
      cognito_user_id: z.string().uuid(),
      first_name: z.string(),
      last_name: z.string(),
      email: z.string(),
      phone_number: z.string(),
      role_name: z.string(),
      tenant_type: TenantType,
    }),
  ),
})
export type GetUsersResponse = z.infer<typeof GetUsersResponse>
